<mat-form-field appearance="outline" class="patient-filter-field" subscriptSizing="dynamic">
    <mat-icon matPrefix>search</mat-icon>
    <input type="text" matInput placeholder="Search patient by name..." [formControl]="searchControl"
        [matAutocomplete]="auto">
    @if (searchControl.value) {
    <button matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
        <mat-icon>close</mat-icon>
    </button>
    }
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onPatientSelected($event)">
        @if (isLoading) {
        <mat-option disabled>Loading...</mat-option>
        }
        @for (patient of filteredPatients$ | async; track patient.id) {
        <mat-option [value]="patient" class="patient-option">
            <div class="patient-info g-just-flex" style="flex-direction: column; align-items: flex-start; justify-content: center; line-height: 1.2; padding: 8px 0;">
                <span class="patient-name" style="font-weight: 500; font-size: 14px;">{{ patient.name | patientName }}</span>
                <span class="patient-meta text-muted" style="font-size: 12px; margin-top: 4px;">
                    <mat-icon style="font-size: 14px; width: 14px; height: 14px; vertical-align: middle; margin-right: 4px;">badge</mat-icon>
                    {{ getPatientPid(patient) }} • {{ (patient.birthDate || '') | patientAge:false }} • {{ patient.gender | titlecase }}
                </span>
            </div>
        </mat-option>
        }
    </mat-autocomplete>
</mat-form-field>
